<div class="recap--filter-typeahead">
  <input type="text" (input)="search(itemTypeID, $event.target.value)" (keydown)="handleKeyDownEvent($event)"
    [(ngModel)]="inputValue" [placeholder]="placeholder" />
  <ul *ngIf="searchResults.length > 0">
    <li *ngFor="let result of searchResults | typeahead:inputValue" (click)="selectItem(result)" 
    [innerHTML]="highlightMatch(result.name, inputValue)"
    ></li>
  </ul>
</div>